export const PORTAL_TITLE = "Capital One Travel Portal";
export const SEARCH_EXPERIENCES_TITLE = "Search an activity";
